<mat-chip class="eiq-tag" selected [disableRipple]="true">
  @if (icon()) {
    <fa-icon [icon]="icon()"></fa-icon>
  }
  <span class="eiq-tag__text fs__sm fw__500" [innerHTML]="text()"></span>
</mat-chip>
